import {Outlet, Route, Routes} from "react-router-dom";
import {Urls} from "component/const/Urls";
import CreateShort from "./pages/Short/CreateShort";
import CreateTrans from "./pages/Trans/CreateTrans";
import CreatePrompt from "./pages/Prompt/CreatePrompt";

export const Create = () => {
    return (<>
        <Routes>
            <Route path={Urls.short} Component={CreateShort}/>
            <Route path={Urls.trans} Component={CreateTrans}/>
            <Route path={Urls.prompt} Component={CreatePrompt}/>
        </Routes>
        <Outlet/>
    </>)
}